import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import MasterDocUtils from '../../../../components/_utils/masterDocUtil'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import { Button, Switch, Card, Form, notification, Tabs, Upload, Icon, Row, Col, List, Select, Input, Radio, Drawer, Tooltip } from 'antd'
import _ from 'lodash'
import { hideLoader, showLoader } from '../../../../modules/actions'
import { connect } from 'react-redux'
import styles from './styles.less'
import { RightsWrapper } from '../../../../components/_utils/utils'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'

const Option = Select.Option
const TabPane = Tabs.TabPane
const RadioGroup = Radio.Group

// following variables needed for update country
let docLoaded = null
let countryId = null
let activeTab = '';
let companyDetails
let id = 0

@Form.create()
class AddCountry extends React.Component {
    callback = key => {
        let inputTypes = this.state.inputTypes
        if (key == 6 || key == 10) {
            this.setState({ showSave: 0 })
        } else {
            this.setState({ showSave: 1 })
        }
        activeTab = key;
        if (countryId && inputTypes[key - 1]) {
            // inputTypes[key - 1].opened = true
            let tempObj = {}
            _.each(inputTypes[key - 1].fields, (v, k) => {
                tempObj[v.key] = docLoaded[v.key]
                if (v.key == 'fundVisaChecklist') {
                    _.each(tempObj[v.key], val => {
                        val.url = MEDIA_URL + val.url
                    })
                }

            })
            this.setState({ inputTypes: inputTypes })
            setTimeout(() => {
                this.props.form.setFieldsValue(tempObj)
            }, 10)
        }
        this.resetFormValues();
    }

    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === "" || obj[propName] === null || obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }





    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                if (this.state.processes.length) {
                    values.process = this.state.processes
                }
                if (values && values.stageApplication || values.stageVisaFilling || values.stageVisaApproval) {
                    values.totalConsultancyFee = values.stageApplication + values.stageVisaFilling + values.stageVisaApproval
                }

                if (values && values.mainApplicantVfs || values.spouseVfs || values.child1Vfs || values.child2Vfs || values.child3Vfs || values.child4Vfs) {
                    values.totalVfsFee = values.mainApplicantVfs + values.spouseVfs + values.child1Vfs + values.child2Vfs + values.child3Vfs + values.child4Vfs
                }


                if (values && values.mainApplicantPermitFee || values.spousePermitFee || values.child1PermitFee || values.child2PermitFee || values.child3PermitFee || values.child4PermitFee) {
                    values.totalPermitFee = values.mainApplicantPermitFee + values.spousePermitFee + values.child1PermitFee + values.child2PermitFee + values.child3PermitFee + values.child4PermitFee
                }

                if (this.state.types.length > 0) {
                    const types = this.state.types.map(el => this.clean(el));
                    values.types = types;
                } else {
                    values.types = [];
                }
                if (countryId) {

                    values = { ...values, _id: countryId }
                    dispatch(showLoader())

                    let x = await Request.updateCountry(values)
                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                } else {
                    dispatch(showLoader())
                    let x = await Request.addCountry(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()
                        this.setState({ types: [] })
                        // dispatch('/all-countries')
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }
    setFormValues = async countryId => {
        try {
            let { doc, imgArr } = await Request.getCountry(countryId)

            if (doc) {

                if (doc.types && doc.types.length > 0) {
                    this.setState({ types: doc.types })
                }
                if (doc.process) {
                    // let desk = []
                    // let names = []
                    // _.each(doc.process, (process)=>{
                    //     desk.push(process.desk)
                    //     names.push(process.name)
                    // })
                    // this.props.form.setFieldsValue({values:{names,desk}})
                    this.setState({ processes: doc.process })
                }

                if (doc.totalConsultancyFee) {
                    this.setState({ totalConsultancyFee: doc.totalConsultancyFee })
                }

                doc.mapImage = _.map(doc.mapImage, (item) => {
                    let ind = item.url.indexOf('http')
                    item.url = ind >= 0 ? `${item.url}` : `${MEDIA_URL}${item.url}`
                    return item
                })
                doc.flagImage = _.map(doc.flagImage, (item) => {
                    let ind = item.url.indexOf('http')
                    item.url = ind >= 0 ? `${item.url}` : `${MEDIA_URL}${item.url}`
                    return item
                })

                docLoaded = doc

                let tempObj = {}

                let inputTypes = this.state.inputTypes

                _.each(inputTypes, (val, kk) => {
                    if (kk == '0') {
                        _.each(inputTypes[0].fields, (v, k) => {
                            tempObj[v.key] = docLoaded[v.key]
                        })
                    }

                    if (kk == 'flagImage') {
                    }
                    /*  _.each(val.fields, (v, k) => {
                        let checkInImgArr = _.find(imgArr, (oo) => {
                          return oo.key == v.key
                        })
                        if (checkInImgArr) {
                          v['defaultFileList'] = checkInImgArr.defaultFileList
                        }
                      })*/
                })

                this.props.form.setFieldsValue(tempObj)
            }
        } catch (e) {
            console.log(e)
        }
    }
    exportExcel = async (requestFor) => {
        this.setState({ exportLoading: true })
        let searchParams = new URLSearchParams(this.props.search)
        countryId = searchParams.get('id');
        let x;
        if (requestFor == 'university') {
            x = await Request.exportCountryUniversityCsv(countryId);
        } else if (requestFor == 'courses') {
            x = await Request.exportCountryCoursesCsv(countryId);
        }

        this.setState({ exportLoading: false })
        if (!x.error) {
            window.open(x.url)
        }
    }
    handleChange = async input => {
        let requestFor = (activeTab == 8 ? 'courses' : 'university');
        if (input.fileList.length > 0) {
            if (input.fileList[0].response != undefined) {
                let searchParams = new URLSearchParams(this.props.search)
                countryId = searchParams.get('id');
                let data = {
                    countryId: countryId,
                    filePath: input.fileList[0].response.path
                }
                let x;
                if (requestFor == 'university') {
                    x = await Request.importCountryUniversityCsv(data, countryId);
                } else if (requestFor == 'courses') {
                    x = await Request.importCountryCoursesCsv(data, countryId);
                }
                if (x) {
                    notification.success({
                        message: x.msg
                    })
                }
            }
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            importLoading: false,
            showSave: 1,
            showFiles: 0,
            incentiveTypes: [{ id: 'DIRECT', display: 'Direct' }, { id: 'ASSOCIATE_PARTNER', display: 'Channel Partner' },
            { id: 'FLC', display: 'FLC' }, { id: 'VISITOR_VISA', display: 'Visitor Visa' }],
            types: [],
            type: '',
            editIndex: null,
            incentiveType: '',
            incentivePercentage: '',
            incentiveFlatAmount: '',
            stagesStatus: '',
            telecallorIncentive: '',
            operationManagerIncentive: '',
            counsellorIncentive: '',
            admissionIncentive: '',
            visafileIncentive: '',
            visaApprovedIncentive: '',
            counsellorIncentiveOnRegistration: false,
            totalConsultancyFee: 0,
            showProcessDrawer: true,
            leadStatuses: [],
            processes: [],
            inputTypes: [
                {
                    tabTitle: 'General Info',
                    fields: [
                        { label: 'Country Name', key: 'countryName', required: true },
                        { label: 'Country Code', key: 'countryCode', required: true },
                        { label: 'Country Phone Code', key: 'countryPhoneCode', required: true },
                        { label: 'Currency', key: 'currencyName', required: true },
                        { label: 'Currency Symbol', key: 'currencySymbol', required: true },
                        {
                            label: 'Currency Rate',
                            key: 'currencyRate',
                            type: 'number',
                            required: true
                        }
                    ]
                },
                {
                    tabTitle: 'Costs',
                    fields: [
                        {
                            label: 'Stage 1 (Application)',
                            key: 'stageApplication',
                            type: 'number',
                            prefixComp: <h3>Consultancy </h3>
                        },
                        {
                            label: 'Stage 2 (Visa Filling)',
                            key: 'stageVisaFilling',
                            type: 'number'
                        },
                        {
                            label: 'Stage 3 (Visa Approval)',
                            key: 'stageVisaApproval',
                            type: 'number'
                        },
                        {
                            label: 'Visitor Consultancy Fee',
                            key: 'visitorConsultancyFee',
                            type: 'number',
                            prefixComp: <h3>Visitor Consultancy Fee </h3>
                        },
                        {
                            label: 'Consultancy Type',
                            key: 'visitorConsultancyType',
                            type: 'select',
                            options: ['Per Person', 'Per Family'],
                            onChange: v => {
                                this.props.form.setFieldsValue({ visitorConsultancyType: v })
                            }
                        },
                        {
                            label: 'Main Applicant',
                            key: 'visaFeeMainApplicant',
                            type: 'number',

                            prefixComp: <h3>Visa Fee </h3>
                        },
                        { label: 'Spouse ', key: 'visaFeeSpouse', type: 'number' },
                        { label: 'Child 1 ', key: 'visaFeeChild1', type: 'number' },
                        { label: 'Child 2 ', key: 'visaFeeChild2', type: 'number' },
                        { label: 'Child 3 ', key: 'visaFeeChild3', type: 'number' },
                        { label: 'Child 4 ', key: 'visaFeeChild4', type: 'number' },

                        {
                            label: 'Main Applicant',
                            key: 'mainApplicantVfs',
                            type: 'number',
                            prefixComp: <h3>VFS Fee </h3>
                        },
                        { label: 'Spouse', key: 'spouseVfs', type: 'number' },
                        { label: 'Child 1', key: 'child1Vfs', type: 'number' },
                        { label: 'Child 2', key: 'child2Vfs', type: 'number' },
                        { label: 'Child 3', key: 'child3Vfs', type: 'number' },
                        { label: 'Child 4', key: 'child4Vfs', type: 'number' },
                        {
                            label: 'Main Applicant',
                            key: 'mainApplicantPermitFee',
                            type: 'number',
                            prefixComp: <h3>Resident Permit Fee </h3>
                        },
                        { label: 'Spouse', key: 'spousePermitFee', type: 'number' },
                        { label: 'Child 1', key: 'child1PermitFee', type: 'number' },
                        { label: 'Child 2', key: 'child2PermitFee', type: 'number' },
                        { label: 'Child 3', key: 'child3PermitFee', type: 'number' },
                        { label: 'Child 4', key: 'child4PermitFee', type: 'number' },
                        {
                            label: 'Main Applicant',
                            key: 'livingCostMainApplicant',
                            type: 'number',
                            prefixComp: <h3>Living Cost (Per Year) In Foreign Currency</h3>
                        },
                        { label: 'Spouse', key: 'livingCostSpouse', type: 'number' },
                        { label: 'Child 1', key: 'livingCostChild1', type: 'number' },
                        { label: 'Child 2', key: 'livingCostChild2', type: 'number' },
                        { label: 'Child 3', key: 'livingCostChild3', type: 'number' },
                        { label: 'Child 4', key: 'livingCostChild4', type: 'number' },
                        {
                            label: 'Children Above Five Years ',
                            key: 'childrenAboveAge',
                            type: 'number',
                            prefixComp: <h3>Schooling Cost Per Year(In Foreign Currency)</h3>
                        },
                        {
                            label: 'Main Applicant ',
                            key: 'travelCostMainApplicant',
                            type: 'number',
                            prefixComp: <h3>Travel Cost (In Foreign Currency)</h3>
                        },
                        { label: 'Spouse', key: 'travelCostSpouse', type: 'number' },
                        { label: 'Child', key: 'travelCostChild', type: 'number' },
                        {
                            label: 'Single ',
                            key: 'singleEstimatedCost',
                            type: 'number',
                            prefixComp: <h3>Estimated Cost Per Week (In Foreign Currency)</h3>
                        },
                        { label: 'Family ', key: 'familyEstimatedCost', type: 'number' },
                        {
                            label: 'Air Ticket Type ',
                            key: 'airTicketType',
                            type: 'select',
                            options: ['One Way', 'Two Way'],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    airTicketType: v
                                })
                            }
                        },
                        {
                            label: `Air Ticket Price `,
                            key: 'airTicketPrice',
                            type: 'number'
                        }
                    ]
                },
                {
                    tabTitle: 'Visa/Country Info',
                    fields: [
                        {
                            label: 'Video URL',
                            key: 'videoUrl'
                        },
                        {
                            label: 'Flag Image',
                            key: 'flagImage',
                            type: 'file',
                            limit: 1,
                            defaultFileList: []
                        },
                        { label: 'Map Image', key: 'mapImage', type: 'file' },
                        { label: 'Main States ', key: 'mainStates' },
                        { label: 'Main Cities ', key: 'mainCities' },
                        {
                            label: 'Visa Sub Classes',
                            key: 'visaCategoryId',
                            type: 'select',
                            options: ['571', '572', '573', 'SPP', 'SVP', 'IPP'],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    visaCategoryId: v
                                })
                            }
                        },
                        {
                            label: 'Any Specific Visa Category Requirements',
                            key: 'visaCategoryRequirements',
                            type: 'textArea',
                            rows: 5
                        },
                        {
                            label: 'Embassy Address',
                            key: 'embassyAddress',
                            type: 'textArea',
                            rows: 5
                        },
                        { label: 'Embassy Contact', key: 'embassyContacts', min: '10' },
                        { label: 'Embassy Email', key: 'embassyEmail' },
                        {
                            label: 'VFS/TTS Address :',
                            key: 'vfsttsAddress',
                            type: 'textArea',
                            rows: 5
                        },
                        { label: 'VFS/TTS Contact :', key: 'vfsttsContacts' },
                        { label: 'VFS/TTS Email Id :', key: 'vfsttsEmail' },
                        {
                            label: 'Visa Filling By',
                            key: 'visaFillingBy',
                            type: 'select',
                            options: ['Agent', 'Applicant', 'Either'],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    visaFillingBy: v
                                })
                            }
                        },
                        {
                            label: 'Visa Filed By CP',
                            key: 'visaFilledByCP',
                            type: 'switch',
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    visaFilledByCP: v
                                })
                            }
                        },
                        {
                            label: 'Multi-Course Approval',
                            key: 'multiCourseApproval',
                            type: 'switch',
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    multiCourseApproval: v
                                })
                            }
                        },
                        {
                            label: 'Interview ',
                            key: 'interview',
                            type: 'select',
                            options: ['Yes', 'No', 'May Be'],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    interview: v
                                })
                            }
                        },
                        { label: 'Part Time Work', key: 'partTimeWork' },
                        {
                            label: 'Standard Visa Processing Time',
                            key: 'visaProcessingTime'
                        },
                        { label: 'Tution Fee Requirement', key: 'tutionFeeReq' },
                        {
                            label: 'Single',
                            key: 'singleOSHC',
                            prefixComp: (
                                <h3>Estimated Medical/OSHC Per Year (In Foreign Currency)</h3>
                            ),
                            type: 'number'
                        },
                        { label: 'Dual', key: 'dualOSHC', type: 'number' },
                        { label: 'Family', key: 'familyOSHC', type: 'number' },
                        {
                            label: 'AHM URL',
                            key: 'AHM',
                            prefixComp: <h3>Check Quote Link</h3>
                        },
                        { label: 'NIB URL', key: 'NIB' },
                        { label: 'Allainze URL', key: 'allainze' },
                        { label: 'MediBank URL', key: 'mediBank' },
                        { label: 'Buppa URL', key: 'buppa' }
                    ]
                },
                {
                    tabTitle: 'Funds/Sponsors/Checklist',
                    fields: [
                        {
                            label: 'Acceptable Funds',
                            key: 'fundAcceptable',
                            type: 'textArea',
                            rows: 5
                        },
                        {
                            label: 'Refundable Foreign Bank Deposit(currency)',
                            key: 'fundRefundable'
                        },
                        {
                            label: 'Acceptable Sponsors',
                            key: 'fundSponsors',
                            type: 'textArea',
                            rows: 5
                        },
                        {
                            label: 'Education loan Acceptable',
                            key: 'fundEducation',
                            type: 'select',
                            options: ['Yes', 'No'],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    fundEducation: v
                                })
                            }
                        },
                        { label: 'Visa Checklist', key: 'fundVisaChecklist', type: 'file' }
                    ]
                },
                {
                    tabTitle: 'Basic Enrollment Info',

                    fields: [
                        {
                            label: 'Basic Admission Documents',
                            key: 'enrollmentBasic',
                            type: 'textArea',
                            rows: 5
                        },
                        {
                            label: 'Any Remarks',
                            key: 'enrollmentRemarks',
                            type: 'textArea',
                            rows: 5
                        },
                        {
                            label: 'Procedure Steps',
                            key: 'enrollmentProcedure',
                            type: 'textArea',
                            rows: 5
                        }
                    ]
                }
            ]
        }
    }

    resetFormValues() {
        let searchParams = new URLSearchParams(this.props.search)

        countryId = searchParams.get('id')

        if (countryId) {
            this.setState({ showFiles: 1 })
            this.setFormValues(countryId)
        }
    }

    async getCompanyDetails() {
        let companyDetail = JSON.parse(localStorage.getItem('company-details'))
        let inputTypes = this.state.inputTypes
        inputTypes[1]["fields"][0].prefixComp = <h3>Student Visa Consultancy {companyDetail && companyDetail.companyCurrency ? companyDetail.companyCurrency : ''}</h3>
        inputTypes[1]["fields"][3].prefixComp = <h3>Visitor Consultancy {companyDetail && companyDetail.companyCurrency ? companyDetail.companyCurrency : ''}</h3>
        inputTypes[1]["fields"][5].prefixComp = <h3>Visa Fee {companyDetail && companyDetail.companyCurrency ? companyDetail.companyCurrency : ''}</h3>
        inputTypes[1]["fields"][11].prefixComp = <h3>VFS Fee {companyDetail && companyDetail.companyCurrency ? companyDetail.companyCurrency : ''}</h3>
        inputTypes[1]["fields"][36].label = `Air Ticket Price (${companyDetail && companyDetail.companyCurrency ? companyDetail.companyCurrency : ''})`
        this.setState({ inputTypes })
    }

    componentDidMount() {
        this.getCompanyDetails()
        this.resetFormValues();
        this.getAllLeadStatuses();
    }

    getAllLeadStatuses = async () => {
        let response = await Request.getLeadStatusDetails({
            results: 1000,
            count: 1000
        });
        if (response && response.data) {
            const allowedLeadStatuses = response.data.filter(ls => ls.desk && (ls.desk.includes('Application Desk') || ls.desk.includes('Visa Desk')));
            this.setState({ leadStatuses: allowedLeadStatuses });
        }
    }



    //------------- types

    validStages = () => {

        let { stagesStatus, telecallorIncentive, operationManagerIncentive, counsellorIncentive, counsellorIncentiveOnRegistration, admissionIncentive, visafileIncentive, incentivePercentage, visaApprovedIncentive,
            incentiveFlatAmount, totalConsultancyFee } = this.state;

        const multiply = incentivePercentage ? incentivePercentage : incentiveFlatAmount;
        const partialAmount = (totalConsultancyFee && incentivePercentage) ? (totalConsultancyFee * multiply / 100) : incentiveFlatAmount;
        const stagesSum = Number(operationManagerIncentive) + Number(telecallorIncentive) + Number(counsellorIncentive) + Number(admissionIncentive) + Number(visafileIncentive) + Number(visaApprovedIncentive);

        if (stagesStatus == 'PERCENTAGE' && (stagesSum > 100)) {
            notification.error({
                message: 'Error',
                description: 'Stages total amount cannot greater than 100.'
            })
            return false;
        }

        if (stagesStatus == 'FLAT_AMOUNT' && (stagesSum > partialAmount)) {
            notification.error({
                message: 'Error',
                description: `Stages total amount cannot greater than ${partialAmount}`
            })
            return false;
        }

        return true;
    }

    addToStages = () => {
        if (!this.state.type) {
            notification.error({
                message: 'Error',
                description: 'Type is required'
            })
            return false;
        }
        if (!this.state.incentivePercentage && !this.state.incentiveFlatAmount) {
            notification.error({
                message: 'Error',
                description: 'Incentive Percentage or Amount is required'
            })
            return false;
        }
        let tempArr = this.state.types;

        const isValid = this.validStages();
        if (!isValid) {
            return;
        }

        tempArr.push({
            type: this.state.type,
            incentiveType: this.state.incentivePercentage ? 'PERCENTAGE' : 'FLAT_AMOUNT',
            incentivePercentage: this.state.incentivePercentage,
            incentiveFlatAmount: this.state.incentiveFlatAmount,
            stagesStatus: this.state.stagesStatus,
            telecallorIncentive: this.state.telecallorIncentive,
            operationManagerIncentive: this.state.operationManagerIncentive,
            counsellorIncentive: this.state.counsellorIncentive,
            admissionIncentive: this.state.admissionIncentive,
            visafileIncentive: this.state.visafileIncentive,
            visaApprovedIncentive: this.state.visaApprovedIncentive,
        })
        this.setState({
            types: tempArr, type: null, incentiveType: null, incentivePercentage: null, incentiveFlatAmount: null,
            stagesStatus: null, operationManagerIncentive: null, telecallorIncentive: null, counsellorIncentive: null, admissionIncentive: null, visafileIncentive: null, visaApprovedIncentive: null
        })
    }
    editStages = (row, index) => {
        this.setState({
            type: row.type, incentiveType: row.incentiveType, incentivePercentage: row.incentivePercentage, incentiveFlatAmount: row.incentiveFlatAmount,
            stagesStatus: row.stagesStatus, operationManagerIncentive: row.operationManagerIncentive, telecallorIncentive: row.telecallorIncentive, counsellorIncentive: row.counsellorIncentive, admissionIncentive: row.admissionIncentive, visafileIncentive: row.visafileIncentive, visaApprovedIncentive: row.visaApprovedIncentive,
            editIndex: index
        })
    }

    // remove = (index) => {
    //     let keys = this.state.processes.length > 0 ? this.state.processes : [];
    //     if (keys.length > 0 && keys[index] != undefined) {
    //         delete keys[index];
    //         this.setState({ processes: keys });
    //     }
    // };

    remove = (index) => {
        let keys = [...this.state.processes]; // Create a copy to avoid mutating state directly
        if (index >= 0 && index < keys.length) {
            keys.splice(index, 1); // Removes the element at the given index
            this.setState({ processes: keys });
        }
    };

    reorderProcess = (fromIndex, toIndex) => {
        if (fromIndex === toIndex || isNaN(fromIndex)) {
            return;
        }
        let keys = [...this.state.processes];
        let [moved] = keys.splice(fromIndex, 1);
        keys.splice(toIndex, 0, moved);
        this.setState({ processes: keys });
    };


    add = () => {
        let keys = this.state.processes.length > 0 ? this.state.processes : [];
        keys.push({
            active: true,
            name: '',
            desk: '',
            systemKey: null
        })
        this.setState({ processes: keys });
    };

    setProcessValue = (field, index, value) => {
        let keys = this.state.processes.length > 0 ? this.state.processes : [];
        if (keys.length > 0 && keys[index] != undefined) {
            keys[index][field] = value;
            this.setState({ processes: keys });
        }
    }

    updateStage = () => {
        if (!this.state.type) {
            notification.error({
                message: 'Error',
                description: 'Type is required'
            })
            return false;
        }
        if (!this.state.incentivePercentage && !this.state.incentiveFlatAmount) {
            notification.error({
                message: 'Error',
                description: 'Incentive Percentage or Amount is required'
            })
            return false;
        }
        let { editIndex, type, incentivePercentage, incentiveFlatAmount } = this.state;
        let tempArr = this.state.types;

        const isValid = this.validStages();
        if (!isValid) {
            return;
        }

        tempArr[editIndex] = {
            type: type,
            incentiveType: this.state.incentivePercentage ? 'PERCENTAGE' : 'FLAT_AMOUNT',
            incentivePercentage: incentivePercentage,
            incentiveFlatAmount: incentiveFlatAmount,
            stagesStatus: this.state.stagesStatus,
            telecallorIncentive: this.state.telecallorIncentive,
            operationManagerIncentive: this.state.operationManagerIncentive,
            counsellorIncentive: this.state.counsellorIncentive,
            admissionIncentive: this.state.admissionIncentive,
            visafileIncentive: this.state.visafileIncentive,
            visaApprovedIncentive: this.state.visaApprovedIncentive,
        };
        this.setState({
            types: tempArr, type: null, incentiveType: null, incentivePercentage: null, incentiveFlatAmount: null, editIndex: null,
            stagesStatus: null, operationManagerIncentive: null, telecallorIncentive: null, counsellorIncentive: null, admissionIncentive: null, visafileIncentive: null, visaApprovedIncentive: null
        })

    }

    renderStatus = (val) => {
        if (val === "DIRECT") {
            return <div >{'Direct'}</div>;
        }
        if (val === "ASSOCIATE_PARTNER") {
            return <div >{'Associate Partner/Branch'}</div>;
        }
        if (val === "FLC") {
            return <div >{'FLC'}</div>;
        }
        if (val === "VISITOR_VISA") {
            return <div>{'Visitor Visa'}</div>
        }
    };




    removeIn = sss => {
        let arr = this.state.types
        arr = arr.filter((val, i) => i !== sss)
        this.setState({ types: arr })
    }

    render() {
        const { submitting } = this.props
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props

        const { editorState,
            types,
            type,
            incentiveTypes,
            incentivePercentage,
            incentiveFlatAmount,
            stagesStatus,
            telecallorIncentive,
            operationManagerIncentive,
            counsellorIncentive,
            admissionIncentive,
            totalConsultancyFee,
            visafileIncentive,
            visaApprovedIncentive } = this.state;

        const stageTypesOptions = incentiveTypes.filter(stage => -1 == types.findIndex(el => el.type == stage.id));

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                md: { span: 4 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                md: { span: 8 },
                sm: { span: 12 }
            }
        }

        const submitFormLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 10, offset: 7 },
                md: { span: 12, offset: 8 }
            }
        }

        const formProps = {
            getFieldDecorator,
            getFieldValue
        }

        const stagesOption = [
            { label: 'Percentage', value: 'PERCENTAGE' },
            { label: 'Flat Amount', value: 'FLAT_AMOUNT' }
        ]
        let searchParams = new URLSearchParams(this.props.search)

        countryId = searchParams.get('id')
        const multiply = incentivePercentage ? incentivePercentage : incentiveFlatAmount;
        const partialAmount = (totalConsultancyFee && incentivePercentage) ? (totalConsultancyFee * multiply / 100) : incentiveFlatAmount;


        // Test Section Start

        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 20, offset: 4 },
            },
        };
        let keys = this.state.processes.length > 0 ? this.state.processes : [];
        let formItems = [];
        keys.map((key, index) => {
            formItems.push(
                <div
                    key={index}
                    draggable
                    onDragStart={(e) => { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(index)); }}
                    onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; }}
                    onDrop={(e) => { e.preventDefault(); this.reorderProcess(parseInt(e.dataTransfer.getData('text/plain'), 10), index); }}
                    style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}
                >
                    <span style={{ cursor: 'move', marginRight: 8, fontSize: 16, color: '#999' }} title="Drag to reorder">⋮⋮</span>
                    <Select 
                        key={`status_${index}`}
                        showSearch
                        onChange={(val) => { this.setProcessValue('name', index, val) }} 
                        value={keys[index].name || undefined} 
                        placeholder={`Status ${index + 1}`} 
                        style={{ width: '30%', marginRight: 8 }}
                    >
                        {this.state.leadStatuses.map(item => (
                            <Option key={item._id} value={item.statusName}>
                                {item.statusName}
                            </Option>
                        ))}
                    </Select>
                    <Select placeholder={`Desk ${index + 1}`} onChange={(e) => { this.setProcessValue('desk', index, e) }} value={keys[index].desk} style={{ width: '30%', marginRight: 8 }}>
                        <Option value={"Application Status"}>Application Status</Option>
                        <Option value={"Application Offer Status"}>Application Offer Status</Option>
                        <Option value={"Student File Status"}>Student File Status</Option>
                        <Option value={"Visa File Status"}>Visa File Status</Option>
                        <Option value={"Refund Status"}>Refund Status</Option>
                    </Select>
                    <Select placeholder={`System Trigger ${index + 1}`} onChange={(e) => { this.setProcessValue('systemKey', index, e === 'None' ? null : e) }} value={keys[index].systemKey || 'None'} style={{ width: '30%', marginRight: 8 }}>
                        <Option value={"None"}>None</Option>
                        <Option value={"Visa Approved"}>Visa Approved</Option>
                        <Option value={"Visa Refused"}>Visa Refused</Option>
                        <Option value={"Visa Withdrawal"}>Visa Withdrawal</Option>
                        <Option value={"Visa File Dispatched"}>Visa File Dispatched</Option>
                        <Option value={"Processed"}>Processed</Option>
                        <Option value={"Conditional Offer Received"}>Conditional Offer Received</Option>
                        <Option value={"Unconditional Offer Received"}>Unconditional Offer Received</Option>
                    </Select>
                    {keys.length > 1 ? (
                        <Icon
                            className="dynamic-delete-button"
                            type="minus-circle-o"
                            onClick={() => this.remove(index)}
                        />
                    ) : null}
                </div>
            )
        });


        // Test Section End

        return (
            <PageHeaderWrapper title={`${countryId ? 'Edit' : 'Add New'} Country`}>
                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <Card bordered={true}>
                        {this.state.showSave ? (
                            <Button
                                type="primary"
                                style={{ marginBottom: 10 }}
                                htmlType="submit"
                                loading={this.props.loading}>
                                SAVE
                            </Button>
                        ) : null}
                        <Tabs onChange={this.callback} type="card">
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <TabPane tab={itype.tabTitle} key={key + 1}>
                                        <GetAllFormFields
                                            apiurl={LAPI_URL}
                                            inputSchema={this.state.inputTypes[key]}
                                            {...formProps}
                                        />
                                    </TabPane>
                                )
                            })}

                            {this.state.showFiles ? (
                                <TabPane tab={'Files'} key={this.state.inputTypes.length + 1}>
                                    <MasterDocUtils type={'country'} _id={countryId} />
                                </TabPane>
                            ) : null}
                            {countryId ? (
                                <TabPane tab={'University'} key={this.state.inputTypes.length + 2}>
                                    {<Card>
                                        <div>
                                            <Button
                                                className={styles.btn}
                                                loading={this.state.exportLoading}
                                                onClick={() => { this.exportExcel('university') }}
                                                type="primary">Export
                                            </Button>

                                            <Upload
                                                loading={this.state.importLoading}
                                                action={`${LAPI_URL}/filesUploader`}
                                                onChange={this.handleChange}>
                                                <Button>
                                                    <Icon type="upload" /> Import
                                                </Button>
                                            </Upload>
                                        </div>
                                    </Card>}
                                </TabPane>)
                                : null}
                            {countryId ? (
                                <TabPane tab={'Courses'} key={this.state.inputTypes.length + 3}>
                                    {<Card>
                                        <div>
                                            <Button
                                                className={styles.btn}
                                                loading={this.state.exportLoading}
                                                onClick={() => { this.exportExcel('courses') }}
                                                type="primary">Export
                                            </Button>

                                            <Upload
                                                loading={this.state.importLoading}
                                                action={`${LAPI_URL}/filesUploader`}
                                                onChange={this.handleChange}>
                                                <Button>
                                                    <Icon type="upload" /> Import
                                                </Button>
                                            </Upload>
                                        </div>
                                    </Card>}
                                </TabPane>)
                                : null}

                            <TabPane tab={'Incentives'} key={this.state.inputTypes.length + 4}>
                                <RightsWrapper myRight={'CountryIncentiveTab.view'}>
                                    {<Card>
                                        <Row className=''>

                                            <Col span={24}>
                                                <Row style={{ marginBottom: 10 }}>
                                                    <Col span={4} style={{ textAlign: 'right', paddingRight: 10 }}>
                                                        <h4>Consultancy Fee : </h4>
                                                    </Col>
                                                    <Col span={16} >
                                                        <Input
                                                            value={this.state.totalConsultancyFee}
                                                            placeholder={'ConsultancyFee'}
                                                            disabled={true}
                                                            style={{ width: "150px" }}
                                                            onChange={ei => { }}
                                                        />
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col span={4} style={{ textAlign: 'right', paddingRight: 10 }}>
                                                        <h4>Types : </h4>
                                                    </Col>
                                                    <Col span={16} >

                                                        <Select
                                                            value={type}
                                                            allowClear={true}
                                                            placeholder={"Select Type"}
                                                            disabled={this.state.editIndex != null}
                                                            // style={{ width: "200px" }}
                                                            className={'knowledge-base-input'}
                                                            onChange={(val) => {
                                                                this.setState({ type: val });
                                                            }}
                                                        >
                                                            <Option value={null}>Select Type</Option>
                                                            {stageTypesOptions.map((item, key) => {
                                                                return (
                                                                    <Option key={key} value={item.id}>{item.display}</Option>
                                                                )
                                                            })}
                                                        </Select>

                                                        <h4>Incentive Percentage </h4>
                                                        <Input
                                                            value={incentivePercentage}
                                                            placeholder={'Enter Incentive Percentage'}
                                                            onChange={ei => {
                                                                this.setState({
                                                                    incentivePercentage: ei.target.value,
                                                                    incentiveFlatAmount: ''
                                                                })
                                                            }}
                                                        />
                                                        <div style={{ textAlign: 'center', margin: 5 }}><span>OR</span></div>
                                                        <h4>Incentive Amount </h4>
                                                        <Input
                                                            value={incentiveFlatAmount}
                                                            placeholder={'Enter Incentive Amount'}
                                                            className={'knowledge-base-input'}
                                                            onChange={ei => {
                                                                this.setState({
                                                                    incentiveFlatAmount: ei.target.value,
                                                                    incentivePercentage: ''
                                                                })
                                                            }}
                                                        />
                                                        <h4>Partial Amount </h4>
                                                        <Input
                                                            value={partialAmount}
                                                            placeholder={'Partial Amount'}
                                                            disabled={true}
                                                            style={{ width: "150px" }}
                                                            onChange={ei => { }}
                                                        />

                                                        <div style={{ textAlign: 'center', margin: 5, fontStyle: 'bold' }}><span>Stages</span></div>
                                                        <RadioGroup
                                                            options={stagesOption}
                                                            style={{ marginBottom: 20 }}
                                                            required={true}
                                                            onChange={v => {
                                                                this.setState({
                                                                    stagesStatus: v.target.value
                                                                })
                                                            }}
                                                            value={stagesStatus}
                                                        />
                                                        {stagesStatus && (
                                                            <>
                                                                <h4>Operation Manager Incentive</h4>
                                                                <Input
                                                                    value={operationManagerIncentive}
                                                                    placeholder={'Enter Operation Manager Incentive'}
                                                                    className={'knowledge-base-input'}
                                                                    onChange={ei => {
                                                                        this.setState({
                                                                            operationManagerIncentive: ei.target.value
                                                                        })
                                                                    }}
                                                                />
                                                                <h4>Telecaller Incentive </h4>
                                                                <Input
                                                                    value={telecallorIncentive}
                                                                    placeholder={'Enter Telecaller Incentive'}
                                                                    className={'knowledge-base-input'}
                                                                    onChange={ei => {
                                                                        this.setState({
                                                                            telecallorIncentive: ei.target.value
                                                                        })
                                                                    }}
                                                                />
                                                                <h4>Counsellor Incentive </h4>
                                                                <Input
                                                                    value={counsellorIncentive}
                                                                    placeholder={'Enter Counsellor Incentive'}
                                                                    className={'knowledge-base-input'}
                                                                    onChange={ei => {
                                                                        this.setState({
                                                                            counsellorIncentive: ei.target.value
                                                                        })
                                                                    }}
                                                                />
                                                                <h4>Admission Incentive </h4>
                                                                <Input
                                                                    value={admissionIncentive}
                                                                    placeholder={'Enter Admission Incentive'}
                                                                    className={'knowledge-base-input'}
                                                                    onChange={ei => {
                                                                        this.setState({
                                                                            admissionIncentive: ei.target.value
                                                                        })
                                                                    }}
                                                                />
                                                                <h4>Visa Support Incentive </h4>
                                                                <Input
                                                                    value={visafileIncentive}
                                                                    placeholder={'Enter Visa Support Incentive'}
                                                                    className={'knowledge-base-input'}
                                                                    onChange={ei => {
                                                                        this.setState({
                                                                            visafileIncentive: ei.target.value
                                                                        })
                                                                    }}
                                                                />
                                                                <h4>Visa Approved Incentive </h4>
                                                                <Input
                                                                    value={visaApprovedIncentive}
                                                                    placeholder={'Enter Visa Approved Incentive'}
                                                                    className={'knowledge-base-input'}
                                                                    onChange={ei => {
                                                                        this.setState({
                                                                            visaApprovedIncentive: ei.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </>
                                                        )}

                                                    </Col>
                                                    <Col span={4} style={{ paddingLeft: 10 }}>
                                                        {
                                                            this.state.editIndex != null ?
                                                                <Button
                                                                    onClick={this.updateStage}>
                                                                    Update TYPE
                                                                </Button>
                                                                :
                                                                <Button
                                                                    onClick={this.addToStages}>
                                                                    ADD TO TYPES
                                                                </Button>
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginLeft: 89 }}>
                                                    <Col span={22}>
                                                        <List
                                                            size="small"
                                                            header={<List.Item>
                                                                <Row style={{ width: '100%' }}>
                                                                    <Col span={2}>
                                                                        <span style={{ fontWeight: 'bold' }}>Type</span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Incentive Percentage</span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Incentive Amount</span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Stage Amount type</span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Operation Manager </span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Telecaller </span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Counsellor </span>
                                                                    </Col>
                                                                    <Col span={3} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Admission Amount</span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Visa File</span>
                                                                    </Col>
                                                                    <Col span={2} style={{ textAlign: 'center' }}>
                                                                        <span style={{ fontWeight: 'bold' }}>Visa Approved</span>
                                                                    </Col>
                                                                    <Col span={3}>
                                                                        <span style={{ fontWeight: 'bold' }}>Action</span>
                                                                    </Col>
                                                                </Row>
                                                            </List.Item>}
                                                            bordered
                                                            dataSource={types}
                                                            renderItem={(val, index) => (
                                                                <>

                                                                    <List.Item>
                                                                        <Row style={{ width: '100%' }}>
                                                                            <Col span={2}>
                                                                                {this.renderStatus(val.type)}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.incentivePercentage ? `${val.incentivePercentage}%` : '-'}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.incentiveFlatAmount ? val.incentiveFlatAmount : '-'}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.stagesStatus ? (val.stagesStatus == 'FLAT_AMOUNT' ? 'Flat Amount' : 'Percentage') : '-'}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.operationManagerIncentive ? val.operationManagerIncentive : '-'}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.telecallorIncentive ? val.telecallorIncentive : '-'}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.counsellorIncentive ? val.counsellorIncentive : '-'}
                                                                            </Col>
                                                                            <Col span={3} style={{ textAlign: 'center' }}>
                                                                                {val.admissionIncentive ? val.admissionIncentive : '-'}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.visafileIncentive ? val.visafileIncentive : '-'}
                                                                            </Col>
                                                                            <Col span={2} style={{ textAlign: 'center' }}>
                                                                                {val.visaApprovedIncentive ? val.visaApprovedIncentive : '-'}
                                                                            </Col>

                                                                            <Col span={1}>
                                                                                <a
                                                                                    onClick={() =>
                                                                                        this.editStages(val, index)
                                                                                    }>
                                                                                    Edit
                                                                                </a>
                                                                            </Col>
                                                                            <Col span={2}>
                                                                                <a
                                                                                    onClick={() =>
                                                                                        this.removeIn(index)
                                                                                    }>
                                                                                    Remove
                                                                                </a>
                                                                            </Col>
                                                                        </Row>
                                                                    </List.Item>
                                                                </>
                                                            )}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card>}
                                </RightsWrapper>
                            </TabPane>
                            <TabPane tab={"Processes"} key={this.state.inputTypes.length + 5} >
                                <Card>
                                    {formItems}
                                    <Button type='dashed' onClick={this.add} style={{ width: '90%', marginTop: '10px' }}>
                                        <Icon type="plus" /> Add field
                                    </Button>
                                    {/* <button type="button" onClick={this.add} style={{ width: '60%' }}>
                                        <Icon type="plus" /> Add field
                                    </button> */}
                                    <Form.Item {...formItemLayoutWithOutLabel}>

                                    </Form.Item>
                                    <Form.Item {...formItemLayoutWithOutLabel}>
                                        <Button type="primary" htmlType="submit">
                                            Submit
                                        </Button>
                                    </Form.Item>
                                </Card>
                            </TabPane>
                        </Tabs>
                    </Card>
                </Form>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddCountry)
